import styled from 'styled-components';
import { H3 } from '~typography';
var ModalTitle = styled(H3).withConfig({
  displayName: "ModalTitle",
  componentId: "sc-10wt7z7-0"
})(["margin:0;"]);
export default ModalTitle;